import * as types from './DateTime.types';

const initialState = null;

const globalDateTime = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_GLOBAL_DATETIME:
      return Object.assign({}, state, {
        startDate: action.data.startDate != undefined ? action.data.startDate : (state != null ? state.startDate : undefined),
        endDate: action.data.endDate != undefined ? action.data.endDate : (state != null ? state.endDate : undefined),
        setByReportName: action.data.setByReportName != undefined ? action.data.setByReportName : (state != null ? state.setByReportName : undefined),
        startType: action.data.startType != undefined ? action.data.startType : (state != null ? state.startType : undefined),
        endType: action.data.endType != undefined ? action.data.endType : (state != null ? state.endType : undefined),
      });
    default:
      return state;
  }
};

const getValue = (props, state) => {
  if (props != undefined || props != null){
    return props;
  } else if (state != null || state != undefined){
    return state;
  }
  return null;
}

export default globalDateTime;
